(ns bleene.dag.subs
  (:require
   [applied-science.js-interop :as jsi]
   [clojure.set :as c.set]
   [bleene.utils :as utils]
   [minorodata.app.utils :as app.utils]
   [re-posh.core :as re-posh]
   [re-frame.core :as re-frame]
   [bleene.dag.commons :as commons]))


(defn find-intersections [visible-nodes node-ids]
  (c.set/intersection visible-nodes node-ids))

(def find-intersections-memo (memoize find-intersections))

(defn group-rect [db dag-id group-id]
  (let [visible-nodes   (set (get-in db [:dag dag-id :nodes]))
        nodes-ids       (set (get-in db [:groups group-id :nodes]))
        group-nodes-ids (find-intersections-memo visible-nodes nodes-ids)
        jobs            (get db :jobs)
        nodes           (vals (select-keys jobs group-nodes-ids))

        {:keys [node-width node-height]}     (get-in db [:dag-params])
        padding 30

        {:keys [start-x start-y width height]}
        (utils/calculate-rect-memo nodes {:start-x padding
                                          :start-y (+ padding 36 24)
                                          :end-x   (+ node-width padding)
                                          :end-y   (+ node-height padding padding)})]
    {:x      start-x
     :y      start-y
     :width  width
     :height height}))

(re-frame/reg-sub
 :dag/group-rect
 (fn [db [_ dag-id group-id]]
   (group-rect db dag-id group-id)))


(re-frame/reg-sub
 :dag/layout-rect
 (fn [db [_ dag-id]]
   (let [jobs          (get db :jobs)
         visible-nodes (set (get-in db [:dag dag-id :nodes]))
         nodes         (vals (select-keys jobs visible-nodes))

         {:keys [node-width node-height]}     (get-in db [:dag-params])
         padding 30]
     (utils/calculate-rect nodes {:start-x padding
                                  :start-y padding
                                  :end-x   (+ node-width padding)
                                  :end-y   (+ node-height padding)}))))

(re-frame/reg-sub
 :dag/full
 (fn [db _]
   {:dag        (:dag db)
    :dag-params (:dag-params db)
    :raw-groups (:raw-groups db)
    :raw-data   (:raw-data db)
    :groups     (:groups db)
    :jobs       (:jobs db)
    :connections (:connections db)}))


(defn simple-query [db query-map]
  (reduce-kv (fn [m k v]
               (assoc m k (get-in db v)))
             {}
             query-map))


(re-frame/reg-sub
 :dag/node-ids-for-dag
 (fn [db [_ dag-id]]
   {:show-source? (get-in db [:dag dag-id :show-sources?])
    :node-ids     (get-in db [:dag dag-id :nodes])
    :ts           (get-in db [:dag dag-id :layout-timestamp])}))


(re-frame/reg-sub
 :dag/dag-data
 (fn [db [_ dag-id]]
   (let [dag @(re-frame/subscribe [:dag/full])

         {:keys [show-sources?
                 x y navigate-to node-width node-height
                 scale scale-by min-scale max-scale]
          :or   {x 0 y 0 scale 1}}
         (simple-query dag {:show-sources? [:dag dag-id :show-sources?]
                            :x             [:dag dag-id :x]
                            :y             [:dag dag-id :y]
                            :scale         [:dag dag-id :scale]
                            :navigate-to   [:dag dag-id :navigate-to]
                            :node-width    [:dag-params :node-width]
                            :node-height   [:dag-params :node-height]
                            :scale-by      [:dag-params :scale-by]
                            :min-scale     [:dag-params :min-scale]
                            :max-scale     [:dag-params :max-scale]})


         {:keys [node-ids scale selected-node drawing-edge? node-width node-height connected-nodes listen-events? pos-x pos-y]}
         (simple-query dag {:node-ids        [:dag dag-id :nodes]
                            ; :scale           [:dag dag-id :scale]
                            :pos-x           [:dag dag-id :x]
                            :pos-y           [:dag dag-id :y]
                            ; :selected-node   [:dag dag-id :selected-node]
                            ; :drawing-edge?   [:dag dag-id :drawing-edge?]
                            :connected-nodes [:dag dag-id :connected-nodes]
                            ; :listen-events?  [:dag dag-id :listen-events?]
                            :node-width      [:dag-params :node-width]
                            :node-height     [:dag-params :node-height]})

         nodes  (map (fn [id]
                       (get-in dag [:jobs id]))
                     node-ids)

         nodes  (if show-sources?
                  nodes
                  (filter (fn [node] (= :transform (:type node))) nodes))

         statuses     @(re-posh/subscribe [:transform-status-list/prop :transform-status-list/statuses])
         extract-jobs @(re-posh/subscribe [:extract-job/pull-many])

         last-index   (- (count nodes) 1)


         simple-view?    (< scale 0.4)
         primitive-view? (< scale 0.2)

         stage nil

         client-timezone @(re-posh/subscribe [:app.subs/timezone])

         current-timezone (-> js/Intl
                              (jsi/call :DateTimeFormat)
                              (jsi/call :resolvedOptions)
                              (jsi/get  :timeZone))

         timezone (or client-timezone current-timezone)

         nodes' (map #(merge %
                             {:node-height     node-height
                              :node-width      node-width
                              :drawing-edge?   drawing-edge?
                              :last-index      last-index
                              :dag-id          dag-id
                              :stage           stage
                              :simple-view?    simple-view?
                              :primitive-view? primitive-view?
                              :connected-nodes connected-nodes
                              :selected-node   selected-node
                              :pos-x           pos-x
                              :pos-y           pos-y
                              :scale           scale
                              :extract-jobs    extract-jobs

                              :format-status   (partial app.utils/format-transform-status-js timezone)

                              :on-node-mouseenter   (fn hover [evt]
                                                      (let [stage (jsi/call-in evt [:target :getStage])
                                                            scale (jsi/get-in stage [:attrs :scaleX])]

                                                        (let [transform-id (get-in % [:transform :transform-id])
                                                              master-id    (get-in % [:transform :master-id])]
                                                          (when (and transform-id master-id)
                                                            (re-frame/dispatch [:transform.api/get-latest-version-by-master-id
                                                                                {:master-id master-id
                                                                                 :old-transform-id transform-id}])))

                                                        (when-let [extract (:extract %)]
                                                          (re-frame/dispatch [:connections.api/fetch-extract
                                                                              {:source-id  (:source-id extract)
                                                                               :extract-id (:extract-id extract)}]))

                                                        (when (< scale 0.3)
                                                          (commons/open-tooltip evt (:name %)))))

                              :on-node-mouseleave  (fn blur []
                                                     (re-frame/dispatch [:dag/open-tooltip false]))

                              :on-node-right-click   (fn [evt]
                                                       ; (commons/open-controls evt nil dag-id (or (:id %) (:transform-id %)) (:group-id %) (:master-id %) (:type %) %)
                                                       (commons/open-context-menu evt {:type :node :id (or (:id %) (:transform-id %))}))})
                     nodes)


         {:keys [groups listen-events?]}
         (simple-query dag {:groups         [:dag dag-id :groups]
                            :listen-events? [:dag dag-id :listen-events?]})

         groups' (map (fn [id]

                        (let [{:keys [name nodes type scale selected-group node-width node-height raw-groups edges extracts]}
                              (simple-query dag {:raw-groups     [:raw-groups]
                                                 :name           [:groups id :name]
                                                 :nodes          [:groups id :nodes]
                                                 :type           [:groups id :type]
                                                 ; :scale          [:dag dag-id :scale]
                                                 ; :selected-group [:dag dag-id :selected-group]
                                                 :node-width     [:dag-params :node-width]
                                                 :node-height    [:dag-params :node-height]
                                                 :edges          [:dag dag-id :edges]
                                                 :extracts       [:raw-data :extracts]})

                              {:keys [x y width height]} (group-rect db dag-id id)
                              ;; (get raw-groups id)

                              text-scale   (min
                                            (if (<= 1 scale)
                                              1
                                              (/ 1 scale))
                                            2)
                              selected?    (= id selected-group)
                              empty-group? (seq nodes)
                              transform-group? (= type :group)]

                          {:name name
                           :x x
                           :y y
                           :height height
                           :width width
                           :id id
                           :transform-group transform-group?
                           :on-right-click  (fn [evt]
                                              (commons/open-context-menu evt {:type type :id id}))}))
                      groups)


         groups'  (if show-sources?
                  groups'
                  (filter :transform-group groups'))



         {:keys [edge-ids selected-edge selected-node connected-edges listen-events?]}
         (simple-query dag {:edge-ids        [:dag dag-id :edges]
                            ; :selected-edge   [:dag dag-id :selected-edge]
                            ; :selected-node   [:dag dag-id :selected-node]
                            :connected-edges [:dag dag-id :connected-edges]
                            ; :listen-events?  [:dag dag-id :listen-events?]
                            })


         edges  (map (fn [id]
                       (get-in dag [:connections id]))
                     edge-ids)

         nnn (clj->js (into {} (map #(identity [(get % :id) %]) nodes')))
         ggg (clj->js groups')
         eee (clj->js (into {} (map #(identity [(get % :id) %]) edges)))

         ts (get-in db [:dag dag-id :layout-timestamp])]
     #js {:jobs          nnn
          :groups        ggg
          :edges         eee
          :statuses      (clj->js statuses)
          :ts            ts})))


(re-frame/reg-sub
 :dag/available-dag-layout-options
 (fn [db _]
   (let [available-layouts (:available-dag-layouts db)]
     (when available-layouts
       (map (fn [{:keys [user-id]}]
              (let [{:searchable-user/keys [email]} @(re-posh/subscribe [:searchable-user/pull [:searchable-user/id user-id]])]
                {:value user-id
                 :text  email}))
            available-layouts)))))

(re-frame/reg-sub
 :dag/current-layout-origin
 (fn [db _]
   (get db :layout/origin)))
